export default __webpack_public_path__ + "static/media/pink-bag.e83fdb18.png";